import {createSelector} from 'reselect';
import {Store} from '../../redux/reducers';
import {initialState} from './reducer';

const select = (state: Store) => state.orders || initialState;

const makeSelectOrdersList = () =>
  createSelector(select, subState => subState.ordersList);

const makeSelectAllPostOrders = () =>
  createSelector(select, subState => subState.allPostOrders);

const makeSelectProvinces = () =>
  createSelector(select, subState => subState.provinces);

const makeSelectCities = () =>
  createSelector(select, subState => subState.cities);

const makeSelectOrdersPrintList = () =>
  createSelector(select, subState => subState.ordersPrintList);

const makeSelectAllOrders = () =>
  createSelector(select, subState => subState.allOrdersReport);

const makeSelectAllOrderItems = () =>
  createSelector(select, subState => subState.orderItems);

const makeSelectPostOrder = () =>
  createSelector(select, subState => subState.postOrder);

const makeSelectCurrentPostOrder = () =>
  createSelector(select, subState => subState.currentPostOrder);

const makeSelectPostOrders = () =>
  createSelector(select, subState => subState.postOrders);

const makeSelectLogs = () => createSelector(select, subState => subState.logs);
const makeSelectTPLLogs = () =>
  createSelector(select, subState => subState.tplLogs);

const makeSelectBundleAssignment = () =>
  createSelector(select, subState => subState.bundleAssignment);

const makeSelectOrder = () =>
  createSelector(select, subState => subState.order);

const makeSelectCountList = () =>
  createSelector(select, subState => subState.count);

const makeSelectPackageCountList = () =>
  createSelector(select, subState => subState.packaged);

const makeSelectResendCountList = () =>
  createSelector(select, subState => subState.resend);

const makeSelectPostOrdersCountList = () =>
  createSelector(select, subState => subState.postOrdersCount);

const makeSelectLoading = () =>
  createSelector(select, subState => subState.loading);

const makeSelectCitiesLoading = () =>
  createSelector(select, subState => subState.cityLoading);

const makeSelectProvincesLoading = () =>
  createSelector(select, subState => subState.provinceLoading);

const makeSelectError = () =>
  createSelector(select, subState => subState.error);

export default select;
export {
  makeSelectOrdersList,
  makeSelectOrder,
  makeSelectLoading,
  makeSelectCitiesLoading,
  makeSelectProvincesLoading,
  makeSelectCountList,
  makeSelectError,
  makeSelectBundleAssignment,
  makeSelectLogs,
  makeSelectAllOrders,
  makeSelectPostOrder,
  makeSelectPostOrders,
  makeSelectOrdersPrintList,
  makeSelectAllPostOrders,
  makeSelectAllOrderItems,
  makeSelectProvinces,
  makeSelectCities,
  makeSelectCurrentPostOrder,
  makeSelectPostOrdersCountList,
  makeSelectTPLLogs,
  makeSelectPackageCountList,
  makeSelectResendCountList
};
